import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function ProblemSection() {
  return <section className="py-24 bg-slate-900" data-id="element-171">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-173">
          <div className="md:col-span-5" data-id="element-174">
            <ScrollFadeIn direction="right" data-id="element-175">
              <div className="relative" data-id="element-176">
                <div className="absolute inset-0 bg-rose-400/10 blur-2xl rounded-full" data-id="element-177" />
                <div className="relative bg-slate-800 border border-slate-700 p-8 rounded-2xl" data-id="element-178">
                  <AlertTriangle className="w-10 h-10 text-rose-400 mb-6" data-id="element-179" />
                  <h3 className="text-2xl font-serif text-slate-50 mb-4" data-id="element-180">
                    The Survival Loop
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-181">
                    Your brain treats an unread email exactly like a
                    saber-toothed tiger, keeping your cortisol levels spiked
                    24/7.
                  </p>
                </div>
              </div>
            </ScrollFadeIn>
          </div>

          <div className="md:col-span-7 space-y-6" data-id="element-182">
            <ScrollFadeIn delay={0.1} data-id="element-183">
              <h2 className="text-3xl md:text-4xl font-serif text-slate-50 leading-tight" data-id="element-184">
                Your body has been{' '}
                <span className="text-rose-400 italic" data-id="element-185">kidnapped</span>.
              </h2>
            </ScrollFadeIn>

            <ScrollFadeIn delay={0.2} data-id="element-186">
              <p className="text-lg text-slate-300 leading-relaxed" data-id="element-187">
                If you are over 40 and dealing with high stress, your body is
                trapped in a biological survival loop.
              </p>
            </ScrollFadeIn>

            <ScrollFadeIn delay={0.3} data-id="element-188">
              <p className="text-lg text-slate-300 leading-relaxed" data-id="element-189">
                This chronic state does two devastating things: it relocates fat
                directly to your midsection (the{' '}
                <strong className="text-slate-50 font-medium" data-id="element-190">
                  "Cortisol Pouch"
                </strong>
                ) and it eats away at your muscle to create emergency sugar.
              </p>
            </ScrollFadeIn>

            <ScrollFadeIn delay={0.4} data-id="element-191">
              <div className="p-4 border-l-2 border-amber-500 bg-amber-500/5 mt-6" data-id="element-192">
                <p className="text-amber-500 font-medium italic" data-id="element-193">
                  You aren't "getting old"—you are stuck in a survival mode that
                  is holding your metabolism hostage.
                </p>
              </div>
            </ScrollFadeIn>
          </div>
        </div>
      </div>
    </section>;
}